import { CODES_ALL, CountryInfo } from '@marketmuse/config/types/countries';
import config from '@marketmuse/config/configs/countries';

export const getCountryAdjective = (country: string): string => {
  const countryKey = country.toLowerCase() as CODES_ALL;
  const countryInfo = config[countryKey] as CountryInfo;
  return countryInfo.adjective || countryInfo.name;
};
